import { AppButton } from 'components';
import {
  AppModal,
  AppModalBody,
  AppModalFooter,
  AppModalHeader,
} from 'components/molecules/Modal/AppModal';
import useDeleteClass from 'hooks/API/DELETE/useDeleteClass';
import useToaster from 'hooks/useToaster';

function ClassDeleteModal({ modalConfig = {}, closeModal }) {
  const { mutate, isLoading, isError } = useDeleteClass();
  useToaster(isLoading, { type: isError ? 'error' : 'success' });

  function deleteClass() {
    mutate(modalConfig.data ?? {});
    closeModal();
  }

  return (
    <AppModal open={modalConfig.show} closeModal={closeModal} size="md">
      <AppModalHeader>Delete Class</AppModalHeader>
      <AppModalBody>
        <p className="modal-sub-text text-center">Are you sure you want to delete this class?</p>

        <div className="app-l-modal-btn-block">
          <AppButton variantClass="btn-plane p--tint mx-4" onClick={deleteClass}>
            YES<sup>*</sup>
          </AppButton>
          <AppButton variantClass="btn-plane p--tint mx-4" onClick={closeModal}>
            NO
          </AppButton>
        </div>

        <p className="modal-sub-note">
          <sup>*</sup>Please note that this action is irreversible
        </p>
      </AppModalBody>
    </AppModal>
  );
}

export default ClassDeleteModal;
